export default "__VITE_ASSET__Dm35Ba7m__"